var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffice365 = function SvgOffice365(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#office365_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.594 0h-17.19a1.41 1.41 0 0 0-1.405 1.405V3l9.69 3 10.309-3V1.405A1.41 1.41 0 0 0 28.594 0Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.648 15.405c.146-.46.263-.93.35-1.405a.666.666 0 0 0-.333-.577l-.013-.007-.004-.002L20.81 7.24a1.502 1.502 0 0 0-1.623 0L8.35 13.414l-.004.002-.013.007A.666.666 0 0 0 8 14c.087.475.204.944.35 1.405l11.492 8.404 11.806-8.404Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.998 3H17l-2.021 3 2.021 3 7 6h6V9l-6-6Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3h7v6h-7V3Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.998 3h6v6h-6V3Z",
    fill: "#50D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.999 15-7-6h-7v6l7 6 10.831 1.767L24 15Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.999 9h7v6h-7V9Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15h7v6h-7v-6Z",
    fill: "#064A8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.998 15h6v6h-6v-6Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.19 23.217-11.794-8.6.494-.868s10.745 6.12 10.909 6.212c.136.054.288.05.42-.012.154-.086 10.932-6.23 10.932-6.23l.496.869-11.457 8.63Z",
    fill: "#0A2767",
    fillOpacity: 0.498
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.665 14.577-.013.008-.003.002-10.837 6.174a1.498 1.498 0 0 1-1.46.09l3.774 5.061 8.254 1.797v.004A1.5 1.5 0 0 0 32 26.5V14a.667.667 0 0 1-.333.577h-.002Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.998 26.5v-.739l-9.982-5.687-1.205.686a1.498 1.498 0 0 1-1.46.09l3.774 5.061 8.254 1.797v.004a1.5 1.5 0 0 0 .62-1.214l-.001.001Z",
    fill: "#000",
    fillOpacity: 0.047
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.948 26.882 21.006 20.65l-.195.11a1.498 1.498 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004a1.5 1.5 0 0 0 .57-.83Z",
    fill: "#000",
    fillOpacity: 0.098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35 14.59v-.01h-.01l-.03-.02A.652.652 0 0 1 8 14v12.501C8 27.323 8.676 28 9.498 28h21c.125-.001.25-.018.37-.05a.64.64 0 0 0 .18-.06 1.052 1.052 0 0 0 .29-.15l.04-.03L8.35 14.59Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.999 22.666V6.335a1.343 1.343 0 0 0-1.333-1.333H10.03v7.455l-1.68.958-.004.002-.013.007a.667.667 0 0 0-.333.577v10.002V24h8.666a1.343 1.343 0 0 0 1.333-1.332Z",
    fill: "#000",
    fillOpacity: 0.098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 23.666V7.334a1.343 1.343 0 0 0-1.334-1.333H10.03v6.456l-1.68.958-.004.002-.013.007a.667.667 0 0 0-.333.577v11.002V25h7.666A1.343 1.343 0 0 0 17 23.666Zm0-2V7.334a1.343 1.343 0 0 0-1.334-1.333H10.03v6.456l-1.68.958-.004.002-.013.007a.667.667 0 0 0-.333.577v9.002V23h7.666A1.343 1.343 0 0 0 17 21.667Zm-1 0V7.334a1.343 1.343 0 0 0-1.334-1.333H10.03v6.456l-1.68.958-.004.002-.013.007a.667.667 0 0 0-.333.577v9.002V23h6.666A1.343 1.343 0 0 0 16 21.667Z",
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 6h13.332a1.34 1.34 0 0 1 1.333 1.333v13.333a1.34 1.34 0 0 1-1.333 1.333H1.333A1.34 1.34 0 0 1 0 20.666V7.333a1.34 1.34 0 0 1 1.333-1.332Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.867 11.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 9a4.616 4.616 0 0 1 2.413.62 4.138 4.138 0 0 1 1.598 1.733c.385.794.577 1.667.56 2.549a5.901 5.901 0 0 1-.577 2.667 4.24 4.24 0 0 1-1.645 1.794A4.799 4.799 0 0 1 7.963 19a4.728 4.728 0 0 1-2.467-.627 4.204 4.204 0 0 1-1.618-1.736 5.457 5.457 0 0 1-.566-2.52 6.054 6.054 0 0 1 .556-2.649h-.001Zm1.75 4.258c.189.477.509.891.924 1.194a2.41 2.41 0 0 0 1.442.435 2.532 2.532 0 0 0 1.541-.448c.41-.303.722-.72.897-1.197a4.627 4.627 0 0 0 .287-1.666 5.064 5.064 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.386 2.386 0 0 0-1.526-.473 2.492 2.492 0 0 0-1.477.438c-.423.304-.75.721-.944 1.204a4.777 4.777 0 0 0-.007 3.439h-.001Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "office365_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v27.998H0z"
  })))));
};
export default SvgOffice365;